import { AppContext } from '../context';
import { Redirect, Route, Switch } from 'react-router-dom';
import { UserAgent } from '../types';
import CandidatePortal from '../pages/CandidatePortal';
import Confirm from '../pages/Confirm';
import Expired from '../pages/Expired';
import Intro from '../pages/Intro';
import InvalidLink from '../pages/InvalidLink';
import NoResults from '../pages/NoResults';
import PickDays from '../pages/PickDays';
import React, { useContext } from 'react';
import Reschedule from '../pages/Reschedule';
import SchedulingLinkData from '../pages/SchedulingLinkData';
import TimeAlreadyBooked from '../pages/TimeAlreadyBooked';

const RequestAvailabilityRoutes: React.FC = () => {
    const { setUserAgentHeader } = useContext(AppContext);
    setUserAgentHeader(UserAgent.REQUEST_AVAILABILITY);
    return (
        <Switch>
            <Route exact path="/" render={() => <Redirect to="/intro" />} />
            <Route path="/intro/:hash" component={Intro} />
            <Route path="/pickDays/:hash" component={PickDays} />
            <Route path="/confirm/:hash" component={Confirm} />
            <Route path="/reschedule/:hash" component={Reschedule} />
            <Route path="/expired/:hash" component={Expired} />
            <Route path="/no-result/:hash" component={NoResults} />
            <Route path="/invalid-link" component={InvalidLink} />
            <Route path="/time-already-booked/:hash" component={TimeAlreadyBooked} />
            <Route path="/link/:orgName/:customName" component={SchedulingLinkData} />
            <Route path="/candidate-portal/:guestId/:jobId" component={CandidatePortal} />
        </Switch>
    );
};

export default RequestAvailabilityRoutes;
